<template>
  <c-range-chart v-if="!params.node.group" :start="value.start" :end="value.end" :mark="value.mark" :params="params">
    <template #start>
      {{ value.startFormatted }}
    </template>
    <template #end>
      {{ value.endFormatted }}
    </template>
  </c-range-chart>
</template>

<script>
import CRangeChart from '@custom/CRangeChart';

export default {
  name: 'performance-renderer',
  components: {
    CRangeChart
  },
  data() {
    return {
      value: {
        start: 0,
        end: 0,
        mark: 0,
        startFormatted: '0',
        endFormatted: '0'
      }
    };
  },
  mounted() {
    this.value = this.params.valueFormatted;
  },
  methods: {
    refresh(params) {
      this.params = params;
      this.value = params.valueFormatted;
      return true;
    }
  }
};
</script>
